import { render } from "./ContractInfo.vue?vue&type=template&id=751ff248"
import script from "./ContractInfo.vue?vue&type=script&lang=js"
export * from "./ContractInfo.vue?vue&type=script&lang=js"

import "./ContractInfo.vue?vue&type=style&index=0&id=751ff248&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__